import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@optools/components/ui/breadcrumb';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@optools/components/ui/dropdown-menu';
import { ScrollArea } from '@optools/components/ui/scroll-area';
import { ChevronDown } from 'lucide-react';
import React from 'react';

import { useDetailsParams } from '../hooks/useDetailsParams';

const detailReplaceRegex = /(media_|audience_|policy_)/;

export function EsniBreadcrumbs() {
  const { audienceHref, detailsValues, mediaId, setDetailsParam, viewingPolicyName } =
    useDetailsParams();

  if (detailsValues.length > 4) {
    return (
      <Breadcrumb className="mb-4" data-testid="esni-breadcrumbs">
        <BreadcrumbList>
          <DropdownMenu>
            <DropdownMenuTrigger className="flex items-center gap-1">
              Previous Pages
              <ChevronDown />
            </DropdownMenuTrigger>
            <ScrollArea>
              <DropdownMenuContent className="max-h-96 overflow-y-scroll">
                {detailsValues.slice(0, detailsValues.length - 2).map((item, index) => {
                  return (
                    <DropdownMenuItem key={item + index}>
                      <BreadcrumbLink asChild>
                        <button
                          className="w-full text-left"
                          type="button"
                          onClick={() => {
                            setDetailsParam('custom', detailsValues.slice(0, index + 1).join(','));
                          }}>
                          {item.replace(detailReplaceRegex, '')}
                        </button>
                      </BreadcrumbLink>
                    </DropdownMenuItem>
                  );
                })}
              </DropdownMenuContent>
            </ScrollArea>
          </DropdownMenu>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <button
              type="button"
              onClick={() => {
                setDetailsParam(
                  'custom',
                  detailsValues.slice(0, detailsValues.length - 1).join(','),
                );
              }}>
              {detailsValues[detailsValues.length - 2].replace(detailReplaceRegex, '')}
            </button>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <BreadcrumbPage>
                {detailsValues[detailsValues.length - 1].replace(detailReplaceRegex, '')}
              </BreadcrumbPage>
            </BreadcrumbLink>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
    );
  } else if (detailsValues.length > 1) {
    return (
      <Breadcrumb className="mb-4" data-testid="esni-breadcrumbs">
        <BreadcrumbList>
          {mediaId && (
            <>
              <BreadcrumbItem key={mediaId}>
                <BreadcrumbLink asChild>
                  <button onClick={() => setDetailsParam('custom', `media_${mediaId}`)}>
                    {mediaId}
                  </button>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator key={`media-id-sep`} />
            </>
          )}

          {viewingPolicyName && (
            <>
              <BreadcrumbItem key={viewingPolicyName}>
                <BreadcrumbLink asChild>
                  {audienceHref?.length ? (
                    <button
                      type="button"
                      onClick={() => {
                        const value = mediaId
                          ? `media_${mediaId},policy_${viewingPolicyName}`
                          : `policy_${viewingPolicyName}`;

                        setDetailsParam('custom', value);
                      }}>
                      {viewingPolicyName}
                    </button>
                  ) : (
                    <BreadcrumbPage>{viewingPolicyName}</BreadcrumbPage>
                  )}
                </BreadcrumbLink>
              </BreadcrumbItem>
              {audienceHref?.length > 0 && <BreadcrumbSeparator key="viewing-pol-sep" />}
            </>
          )}
          {audienceHref?.length > 0 &&
            audienceHref.map((item, index) =>
              audienceHref.length - 1 === index ? (
                <BreadcrumbItem key={item + index}>
                  <BreadcrumbLink asChild>
                    <BreadcrumbPage>{item}</BreadcrumbPage>
                  </BreadcrumbLink>
                </BreadcrumbItem>
              ) : (
                <React.Fragment key={item + index}>
                  <BreadcrumbItem>
                    <BreadcrumbLink asChild>
                      <button
                        type="button"
                        onClick={() => {
                          let value = mediaId
                            ? `media_${mediaId},policy_${viewingPolicyName}`
                            : `policy_${viewingPolicyName}`;
                          value = `${value},${audienceHref.slice(0, index + 1).map((item) => `audience_${item}`)}`;
                          setDetailsParam('custom', value);
                        }}>
                        {item}
                      </button>
                    </BreadcrumbLink>
                  </BreadcrumbItem>
                  <BreadcrumbSeparator />
                </React.Fragment>
              ),
            )}
        </BreadcrumbList>
      </Breadcrumb>
    );
  } else {
    return null;
  }
}
